import { render, staticRenderFns } from "./AssignedRiskView.vue?vue&type=template&id=75a4d69e&"
import script from "./AssignedRiskView.vue?vue&type=script&lang=ts&"
export * from "./AssignedRiskView.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedRiskView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VCard,VContent})
